/**
 * Sit Shopify Inbox (Online Store Chat) just above sticky ATC.
 *
 * Inbox launcher lives here:
 *   shopify-chat >> shopify-agent-runtime >> .activator-nudge
 * It is position:absolute with its own bottom (often ~88px for
 * preview bar / safe area). Adding margin/translate ON TOP of that
 * pushes the icon mid-page. We replace `bottom` with the sticky
 * bar's top edge + a small gap.
 */
(function () {
  var STYLE_ATTR = 'data-ig-sticky-chat';
  var GAP = 8;
  var MIN_BOTTOM = 40;
  var MAX_BOTTOM = 180;

  function stickyBar() {
    return document.querySelector('#sticky_prodBar');
  }

  function isStickyVisible() {
    var el = stickyBar();
    if (!el || !el.classList.contains('sticky')) return false;
    if (el.style.display === 'none') return false;
    var cs = window.getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none' && parseFloat(cs.opacity) > 0.5;
  }

  function findNudgeShadow() {
    var chat = document.querySelector('shopify-chat');
    if (!chat || !chat.shadowRoot) return null;
    var runtime = chat.shadowRoot.querySelector('shopify-agent-runtime');
    if (!runtime || !runtime.shadowRoot) return null;
    if (!runtime.shadowRoot.querySelector('.activator-nudge')) return null;
    return runtime.shadowRoot;
  }

  function desiredBottom() {
    var el = stickyBar();
    if (!el) return 0;
    var top = el.getBoundingClientRect().top;
    var bottom = Math.round(window.innerHeight - top) + GAP;
    if (bottom < MIN_BOTTOM || bottom > MAX_BOTTOM) return 0;
    return bottom;
  }

  function setNudgeBottom(shadowRoot, px) {
    var style = shadowRoot.querySelector('style[' + STYLE_ATTR + ']');
    if (!px) {
      if (style) style.remove();
      return;
    }
    if (!style) {
      style = document.createElement('style');
      style.setAttribute(STYLE_ATTR, '');
      shadowRoot.appendChild(style);
    }
    style.textContent =
      '.activator-nudge,.activator-nudge--left,.activator-nudge--active{' +
      'bottom:' + px + 'px !important;' +
      'margin-bottom:0 !important;' +
      'transform:none !important;' +
      '}';
  }

  function apply() {
    var shadow = findNudgeShadow();
    if (!shadow) return;
    var show = isStickyVisible();
    setNudgeBottom(shadow, show ? desiredBottom() : 0);
  }

  var scheduled = false;
  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      apply();
    });
  }

  function start() {
    apply();
    window.addEventListener('scroll', scheduleApply, { passive: true });
    window.addEventListener('resize', scheduleApply);

    var bar = stickyBar();
    if (bar) {
      new MutationObserver(scheduleApply).observe(bar, {
        attributes: true,
        attributeFilter: ['class', 'style'],
      });
    }

    var n = 0;
    var tick = setInterval(function () {
      apply();
      if (++n > 30) clearInterval(tick);
    }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
